const state = {
  isLoading: false,
  // loadingMessage: '',
}
const getters = {
  getIsLoading:state => {
    return state.isLoading;
  },
  // getLoadingMessage:state => {
  //   return state.loadingMessage;
  // },
}
const mutations = {
  setIsLoading:(state, bool) => {
    state.isLoading = bool;
  },
  // setLoadingMessage:(state, message) => {
  //   state.loadingMessage = message;
  // },
}

const actions = {
  // 表示したいメッセージの種類が増えてきたら、メッセージの定義を外に出して、関数を一般化します。
  // loading状態にする（メッセージ表示なし）
  startLoading({commit}){
    commit('setIsLoading', true);
  },
  // // loading状態にする（読み込み）
  // startGetLoading({commit}){
  //   commit('setLoadingMessage', 'データを読み込んでいます')
  //   commit('setIsLoading', true);
  // },
  // // loading状態にする（更新）
  // startUpdateLoading({commit}){
  //   commit('setLoadingMessage', 'データを更新しています')
  //   commit('setIsLoading', true);
  // },
  // loading状態を解消する
  endLoading({commit}){
    commit('setIsLoading', false);
    // commit('setLoadingMessage', '')
  },

}
export default {
  state,
  getters,
  mutations,
  actions
}